<template>
  <div class="SubPage__container">
    <PageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <h1 class="SubPage__title">
            <slot name="title" />
          </h1>
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column is-two-thirds">
          <slot name="teaserImage" />
        </div>
        <div class="column is-one-third">
          <SalesContainer :config="salesContainerConfig" />
        </div>
      </div>
    </div>
    <div class="SubPage__contentGrid">
      <h2 class="SubPage__subHeading">
        <slot name="subHeading" />
      </h2>
      <slot name="tabsConfig" />
      <ContactList :config="listConfig" />
    </div>
    <Footer />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Footer from "../Footer/Footer";
import SalesContainer from "../SalesContainer/SalesContainer";
import PageHeader from "../PageHeader/PageHeader";
import CookieDisclaimer from "../CookieDisclaimer/CookieDisclaimer";
import ContactList from "../ContactList/ContactList";

export default {
  name: "ContactListPage",
  components: {
    Breadcrumbs,
    Footer,
    SalesContainer,
    PageHeader,
    CookieDisclaimer,
    ContactList
  },
  props: {
    cookieDisclaimerConfig: {
      default: undefined
    },
    crumbs: {
      default: undefined
    },
    salesContainerConfig: {
      default: undefined
    },
    listConfig: {
      default: undefined
    }
  }
};
</script>
